<div>
  <div class="title title--big">Служебные функции сотрудников</div>
</div>

<div class="mt-32 pt-8">
  <app-role-access [action]="'disable'" [permission]="'service_function.add'" [placement]="'bottom-left'">
    <button data-role-element type="button" class="button" id="appOpenAddServiceFunctionDialog" (click)="onOpenAddServiceFunction()">Добавить функцию</button>
  </app-role-access>
</div>

<div class="pos-r">
  <app-loader *ngIf="serviceFunctionsLoading"></app-loader>
  <app-services-functions-filter
    [isShowDisabled]="isShowHiddenServiceFunctions"
    [functionSelected]="serviceFunctionSelected"
    [functions]="serviceFunctionsFilteredList"
    (onChangeVisibleHiddenServiceFunctions)="onChangeVisibleHiddenServiceFunctions($event)"
    (onApplyServiceFunctionsFilter)="onApplyServiceFunctionsFilter($event)"
    (onResetServiceFunctionsFilter)="onResetServiceFunctionsFilter()"
  ></app-services-functions-filter>
  <app-services-functions-list
    [functions]="serviceFunctionsFilteredList"
    [isActiveShowAllFunctionsButton]="isActiveShowAllFunctionsButton"
    (onChangeVisibilityAllFunctions)="onChangeVisibilityAllFunctions()"
    (onOpenServiceFunctionDialog)="onOpenServiceFunctionDialog($event)"
    (onChangeStateServiceFunction)="onChangeStateServiceFunction($event)"
  ></app-services-functions-list>
</div>
